module.exports = __webpack_public_path__ + "media/Images/woman-in-conversation-e06ae6d1ced00c5e4120cd2f640317d7.jpg";